import { BASE_URL, KEY_LOCALSTORE } from "./constants";
import axios from "axios";
import store from "../store/index";

import SecureLS from "secure-ls";

const ls = new SecureLS({ isCompression: false });

// amount of calling to refresh token for clean storage
let countRefresh = 0;

const ajax = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

var refreshToken = async (error) => {
  if (store.state.login.refreshToken != "") {
    try{
      countRefresh++;
    if(countRefresh > 3){
      ls.remove(KEY_LOCALSTORE)
      window.location.reload()
      countRefresh = 0;
    }

    const resp = await ajax.post(`/api/v1/Auth/refresh-token`, {
      token: store.state.login.refreshToken,
    });
    store.commit("login/SET_TOKENS", resp.data.response);
    ajax.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${resp.data.response.token}`;
    ajax.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8"
    ajax.defaults.headers.put["Content-Type"] = "application/json;charset=UTF-8"
    ajax.defaults.headers.patch["Content-Type"] = "application/json;charset=UTF-8"
    countRefresh = 0;
    return Promise.resolve(true)
  }catch(e){
    debugger
      return Promise.reject(e)
    }

  }else{

    return Promise.reject(error)
  }
};

ajax.interceptors.request.use((config) => {
  var data = ls.get(KEY_LOCALSTORE);
  var objectLocal = data == "" ? null : JSON.parse(data);

  if (objectLocal != null) {
    if (!!objectLocal.login.token) {
      config.headers.common[
    
        "Authorization"
      ] = `Bearer ${objectLocal.login.token}`;
    }
  }

  return config;
});

ajax.interceptors.response.use(
  (resp) => {
    return resp;
  },
  async (error) => {
    const { status, data } = error.response;

    if (error.response) {
      switch (status) {
        case 401:
          try {
            await refreshToken(error);
            const config = error.response.config;
            console.clear()
            return await ajax({
              method: config.method,
              url: config.url,
              data: config.data,
              params: config.params 
            });
          } catch (e) {
            return Promise.reject(e); //(window.location.href = "/error-404");
          }

        default:
          return Promise.reject(error);
      }
    } else if (error.request) {
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }
);

export default ajax;
